export default "__VITE_ASSET__2c2993fc__"